/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteTransaction (id: number) {
  return rest.delete(`/api/transactions/${id}`)
}

export function fetchTransaction (id: number): Promise<Transaction> {
  return rest.get(`/api/transactions/${id}`)
    .then((resp) => resp.json())
}

export function findManyTransactions (params: Record<string, any>): Promise<HalDocument<{
  transactions: Transaction[]
}>> {
  return rest.get(`/api/transactions?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchTransaction (id: number, data: Partial<Transaction>) {
  return rest.patch(`/api/transactions/${id}`, {
    body: JSON.stringify(data),
    headers: { 'content-type': 'application/json' }
  })
}

export function postTransaction (data: Partial<Transaction>) {
  return rest.post('/api/transactions', {
    body: JSON.stringify(data),
    headers: { 'content-type': 'application/json' }
  })
}
